var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 30.0937L35.7656 0H54.2344L15.0469 39.1875L5.76562 30.0937ZM35.7656 60H54.2344L38.25 44.0156L54.2344 27.7031H35.7656L19.7813 43.8281L35.7656 60Z",
    fill: "url(#paint0_linear_1161_1922)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 44.0156L28.875 34.6406L19.7812 43.8281L28.875 53.0156L38.25 44.0156Z",
    fill: "url(#paint1_linear_1161_1922)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2344 60L38.25 44.0156L28.875 53.0156L35.7656 60H54.2344Z",
    fill: "url(#paint2_linear_1161_1922)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 53.0156L43.3125 49.0781L38.25 44.0156L28.875 53.0156Z",
    fill: "url(#paint3_linear_1161_1922)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1161_1922",
    x1: 5.76562,
    y1: 30,
    x2: 54.2344,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1161_1922",
    x1: 19.7812,
    y1: 43.8281,
    x2: 38.25,
    y2: 43.8281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1161_1922",
    x1: 28.875,
    y1: 52.0078,
    x2: 54.2344,
    y2: 52.0078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1161_1922",
    x1: 28.875,
    y1: 48.5156,
    x2: 43.3125,
    y2: 48.5156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.be18990b63e251ec7a31f102ab3edc4c.svg";
export { ForwardRef as ReactComponent };